import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import { ApiError } from './client'

export interface QueryClientOptions {
  /** Called for every failed query/mutation (the app wires the global 401 handling here). */
  onError?: (error: unknown) => void
}

/** Single QueryClient: cache shared by all modules (navigation without reloads). */
export function createQueryClient({ onError }: QueryClientOptions = {}): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({ onError: (error) => onError?.(error) }),
    mutationCache: new MutationCache({ onError: (error) => onError?.(error) }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: (attempts, error) => {
          // don't retry errors that won't change on a new attempt
          if (error instanceof ApiError && error.status !== null && error.status < 500) return false
          return attempts < 2
        },
        refetchOnWindowFocus: true,
      },
    },
  })
}
